import { useConnectModal, useOpenModal } from '@rainbow-modules/hooks';
import { CREATE_SIP_USER_DRAWER } from '../../../../../constants';
import { StyledDrawer } from './styled';
import CreateSipUserForm from './CreateSipUserForm';
import SipUserCreatedModal from './SipUserCreatedModal';

const CreateSipUserDrawer = () => {
    const connectedProps = useConnectModal(
        CREATE_SIP_USER_DRAWER,
        { size: 'small', slideFrom: 'right' },
    );
    const [, closeDrawer] = useOpenModal(CREATE_SIP_USER_DRAWER);
    const {
        agentId,
        domainSid,
        onSubmit,
        ...drawerProps
    } = connectedProps;

    return (
        <>
            <StyledDrawer
                {...drawerProps}
                onRequestClose={closeDrawer}
            >
                <CreateSipUserForm
                    agentId={agentId as string | undefined}
                    onRequestClose={closeDrawer}
                    onSubmit={onSubmit as (values: { username: string }) => Promise<void>}
                />
            </StyledDrawer>
            <SipUserCreatedModal />
        </>
    );
};

export default CreateSipUserDrawer;
